export enum PeriodDate {
    Today = 1,
    Yesterday = 2,
    CurrentWeek = 3,
    LastWeek = 4,
    CurrentMonth = 5,
    LastMonth = 6
}

export function PeriodDateTypeString(PeriodDate: PeriodDate) {
    switch (PeriodDate) {
        case 1:
            return "امروز";
        case 2:
            return "دیروز";
        case 3:
            return "هفته جاری";
        case 4:
            return "هفته گذشته";
        case 5:
            return "ماه جاری";
        case 6:
            return "ماه گذشته";
    }
}